// // src/components/Payment/PaymentWrapper.jsx
// import React, { useState } from 'react';
// import { Elements } from '@stripe/react-stripe-js';
// import { Modal, Tabs } from 'antd';
// import { CreditCardOutlined } from '@ant-design/icons';
// import stripePromise from '../../config/stripeConfig';
// import PaymentForm from './PaymentForm';
// import PayPalPayment from './PayPalPayment';
// import MonerisPayment from './MonerisPayment';

// const PaymentWrapper = ({ visible, course, onSuccess, onError, onCancel }) => {
//   const [activeTab, setActiveTab] = useState('paypal');

//   const tabItems = [
//     // {
//     //   key: 'paypal',
//     //   label: (
//     //     <span>
//     //       <img
//     //         alt="PayPal"
//     //         src="data:image/svg+xml;base64,PHN2ZyB3aW..."
//     //         style={{ width: 16, height: 16, marginRight: 8 }}
//     //       />
//     //       PayPal
//     //     </span>
//     //   ),
//     //   children: (
//     //     <PayPalPayment
//     //       course={course}
//     //       onSuccess={onSuccess}
//     //       onError={onError}
//     //       onCancel={onCancel}
//     //     />
//     //   ),
//     // },
//     // {
//     //   key: 'stripe',
//     //   label: (
//     //     <span>
//     //       <CreditCardOutlined style={{ marginRight: 8 }} />
//     //       Carte bancaire
//     //     </span>
//     //   ),
//     //   children: (
//     //     <Elements stripe={stripePromise}>
//     //       <PaymentForm
//     //         course={course}
//     //         onSuccess={onSuccess}
//     //         onError={onError}
//     //         onCancel={onCancel}
//     //       />
//     //     </Elements>
//     //   ),
//     // },
//     {
//       key: 'moneris',
//       label: <span>💳 Moneris (CB/Interac)</span>,
//       children: (
//         <MonerisPayment
//           course={course}
//           onSuccess={onSuccess}
//           onError={onError}
//         />
//       ),
//     },
//   ];

//   return (
//     <Modal
//       title={<div style={{ textAlign: 'center' }}>🛒 Finaliser votre achat</div>}
//       open={visible}
//       onCancel={onCancel}
//       footer={null}
//       width={700}
//       centered
//       maskClosable={false}
//       destroyOnClose
//     >
//       <div style={{ marginTop: 16 }}>
//         <div
//           style={{
//             padding: 16,
//             background: '#f5f5f5',
//             borderRadius: 8,
//             marginBottom: 24,
//           }}
//         >
//           <h4 style={{ margin: '0 0 8px 0' }}>{course?.title}</h4>
//           <p
//             style={{
//               fontSize: 18,
//               fontWeight: 'bold',
//               color: '#1890ff',
//               margin: 0,
//             }}
//           >
//             {course?.latest_price}€
//           </p>
//         </div>

//         <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} centered />
//       </div>
//     </Modal>
//   );
// };

// export default PaymentWrapper;



// src/components/Payment/PaymentWrapper.jsx
import React from 'react';
import { Modal } from 'antd';
import MonerisPayment from './MonerisPayment';

const PaymentWrapper = ({ visible, course, onSuccess, onError, onCancel }) => {
  return (
    <Modal
      title={<div style={{ textAlign: 'center' }}>🛒 Finaliser votre achats</div>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={760}
      centered
      maskClosable={false}
      destroyOnClose
    >
      <div style={{ marginTop: 8 }}>
        <div
          style={{
            padding: 16,
            background: '#f5f7fb',
            borderRadius: 12,
            marginBottom: 16,
            boxShadow: '0 1px 3px rgba(0,0,0,0.06) inset',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
            <h3 style={{ margin: 0 }}>{course?.title}</h3>
            <span style={{ fontSize: 22, fontWeight: 700, color: '#1677ff' }}>
              {course?.latest_price}€
            </span>
          </div>
        </div>

        {/* 👇 Moneris directement, auto-ouverture du checkout */}
        <MonerisPayment
          course={course}
          onSuccess={onSuccess}
          onError={onError}
          autoStart
        />
      </div>
    </Modal>
  );
};

export default PaymentWrapper;

